<header>
    <h2><a href="#">Goa Travel</a></h2>	
    <nav>
            <li><a href="#">Tours</a></li>
            <li><a href="#">About</a></li>
            <li><a href="#">Contact Us</a></li>
            
    </nav>
    </header>	
    <section class="hero">
        <div class="bkg-img" style="background-image:url('https://farm4.staticflickr.com/3372/3299941029_0074286419_o.jpg');"></div>
        <div class="hero-content">
            <h1>Goa Travel</h1>
            <h3>Unmissable Tours Around Beautiful Goa</h3>
            <a href="#" class="btn">Contact Us Now</a>
        </div>
    </section>
    
    <section class="destinations">
        <h3 class="title">Some Of Our Destinations</h3>
        <p>Love the surf and sand? History buff? Nature enthusiast? Thrill seeker interested in water sports, dolphin sightseeing, backwater kayaking, parasailing, and scuba diving? Goa has something for everyone</p>
        <hr>
        <ul class="grid">
        <li class="small" style="background-image:url('https://farm5.staticflickr.com/4005/4267674623_a786e4a440_o.jpg');"></li>
    <li class="large" style="background-image:url('https://farm9.staticflickr.com/8334/8103080370_254bcd9f90_o.jpg');">
        
    </li>
            <li class="large" style="background-image:url('https://farm6.staticflickr.com/5296/5444152459_2bffa50e90_o.jpg');"></li>
            <li class="small" style="background-image:url('https://farm1.staticflickr.com/211/535585258_84df3cd5f1_o.jpg"></li>
        </ul>	
        
    </section>
                                                             
    <section class="packages">
    <h3 class="title">Tour Packages</h3>		
    <p>We offer a variety of sightseeing and immersion packages. Whether you want to experience the rich culture, immerse yourself in it's natural beauty, or have a relaxing visit, we've got the perfect vacation for you</p>
    <hr>
    <ul class="grid">
        <li>
            <i class="fa fa-compass fa-4x"></i>
            <h4>Guided Tours</h4>
            <p>Looking for the complete experience? Take a tour with one of our experts. Visit the beautiful old temples and churches and the numerous beaches. Sample the local dishes and visit various health or spa retreats to pamper yourself on your vacation. </p>
        </li>
        <li>
            <i class="fa fa-camera-retro fa-4x"></i>
            <h4>Photo Tours</h4>
            <p>Want to experience nature's beauty without all the trekking, walking and waiting? Take a photo tour on one of our luxury buses.</p>
        </li>
        <li>
            <i class="fa fa-motorcycle fa-4x"></i>
            <h4>Bike Tours</h4>
            <p>A fun  way to experience the local atmosphere while seeing as much of Goa as you can. We'll provide the bikes and lunch too!</p>
        </li>
        <li>
            <i class="fa fa-binoculars fa-4x"></i>
            <h4>Safari Tours</h4>
            <p>Looking to see some wildlife? We offer fantastic safari trips! Spend a day out cruising along the back waters of the Zuari River in a giant canoe, returning to camp in the evening to retell your adventures next to the campfire!</p>
        </li>
    </ul>
    </section>	
    
    <section class="testimonials">
        <h3 class="title">Testimonials from Goa travellers:</h3>
        <hr>
        <p  class="quote">A most wonderful place although I gather greatly different to northern India-the people were lovely(although immense haggling which was fun when we caught on)stunning and must go back!</p>
        <p  class="author">-Amanda D'Cunha</p>
        <p  class="quote">We loved everything about Goa, the people are the best we've ever met. The Elephant trip was really good - a must for anyone.</p>
        <p  class="author">-Angelo Fernandes</p>
        <p  class="quote">Very well framed and arranged tour package, I find everything in it like delicious food,spacious rooms,well maintained, disciplined behaviors, well planned vehicles for site scenes. Nothing more to say, contains all things for a travelers.</p>
        <p  class="author">-Diana Monteiro</p>
    </section>
    <section class="contact">
        <h3>Learn More</h3>
        <p>Want to know about upcoming specials, and value deals? Just sign up for our mailing list. We'll keep you informed on new tour packages and offerings. No  spam, we promise!</p>
        <hr>	
        <form>
            <input type="email" />
            <button class="btn">subscribe now </button>
        </form>	
    </section>	
    <footer>
        <p>Images courtesy of <a href="http://www.photosforclass.com/"></a>Photos for Class</p>
    <p>Visit Goa and have a good time doing it, when you use one or more of our tours...</p>
    <ul>
        <li><a href="#"><i class="fa fa-twitter-square fa-2x"></i></a></li>
        <li><a href="#"><i class="fa fa-facebook-square fa-2x"></i></a></li>
        <li><a href="#"><i class="fa fa-snapchat-square fa-2x"></i></a></li>
    </ul>
    </footer>	
                                                             
    <!--
    https://farm5.staticflickr.com/4005/4267674623_a786e4a440_o.jpg
    https://farm9.staticflickr.com/8334/8103080370_254bcd9f90_o.jpg
    https://farm6.staticflickr.com/5296/5444152459_2bffa50e90_o.jpg
    https://farm1.staticflickr.com/211/535585258_84df3cd5f1_o.jpg
    -->														